<nav class="navbar mobile-console-navbar p-0 fixed-top d-block d-lg-flex align-items-center">
  <div class="mobile-navbar-shell d-lg-none w-100 px-3 pt-3 pb-2 bg-white">
    <div class="mobile-navbar-main d-flex align-items-start justify-content-between gap-3">
      <div class="mobile-navbar-title-group d-flex align-items-center gap-2 min-w-0">
        <button
          v-if="is_drive_route"
          type="button"
          class="btn btn-link mobile-navbar-icon-btn text-dark p-0 flex-shrink-0"
          :aria-label="drive_mobile_nav_is_back ? 'Back in Drive' : 'Open Drive menu'"
          @click="emit_drive_mobile_nav"
        >
          <i :class="drive_mobile_nav_is_back ? 'fa-solid fa-arrow-left' : 'fa-solid fa-bars'" aria-hidden="true"></i>
        </button>
        <div
          class="mobile-navbar-title-copy min-w-0 text-start"
          :class="{ 'has-long-mobile-name': mobile_has_long_name }"
        >
          <template v-if="is_dashboard_route">
            <p class="mobile-navbar-title mobile-navbar-greeting fw-bold mb-0 text-start">{{ mobile_dashboard_greeting }}, {{ mobile_first_name }}</p>
            <p class="mobile-navbar-date text-muted mb-0 text-start">{{ mobile_today_label }}</p>
          </template>
          <p v-else class="mobile-navbar-title fw-bold mb-0 text-truncate gradient-text ">{{ mobile_nav_title }}</p>
        </div>
      </div>

      <div class="d-flex align-items-center gap-2 flex-shrink-0 pt-1">
        <div class="dropdown">
          <button
            type="button"
            class="btn btn-link mobile-navbar-icon-btn text-dark p-0"
            id="mobile_app_launcher_btn"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-label="Open My Apps"
          >
            <span class="app-launcher-nine-dot" aria-hidden="true">
              <span></span><span></span><span></span>
              <span></span><span></span><span></span>
              <span></span><span></span><span></span>
            </span>
          </button>

          <div class="dropdown-menu app-grid-dropdown bg-white" aria-labelledby="mobile_app_launcher_btn">
            <div class="app-grid bg-white">
              <a v-if="allowed_app_keys.includes('orcaa')" class="app-item d-flex" @click="launch_platform('orcaa')">
                <div class="app-icon-wrapper d-flex">
                  <img :src="require('@/assets/platforms_icons/orcaa_ai.svg')" alt="Orcaa">
                </div>
              </a>

              <a v-if="allowed_app_keys.includes('workflow')" class="app-item d-flex" @click="launch_platform('workflow')">
                <div class="app-icon-wrapper d-flex">
                  <img :src="require('@/assets/platforms_icons/ProbaWorkflows.png')" alt="Workflows">
                </div>
              </a>

              <a v-if="allowed_app_keys.includes('complyon')" class="app-item d-flex" @click="launch_platform('complyon')">
                <div class="app-icon-wrapper d-flex">
                  <img :src="require('@/assets/platforms_icons/complyon.svg')" alt="Complyon">
                </div>
              </a>

              <a v-if="allowed_app_keys.includes('engagenet')" class="app-item d-flex" @click="launch_platform('engagenet')">
                <div class="app-icon-wrapper d-flex">
                  <img :src="require('@/assets/platforms_icons/engagenet.svg')"
                    :alt="is_internal_suite ? 'IC Workbook' : 'Engagenet'">
                </div>
              </a>

              <a v-if="allowed_app_keys.includes('x-verdict')" class="app-item d-flex" @click="launch_platform('x-verdict')">
                <div class="app-icon-wrapper d-flex">
                  <img :src="require('@/assets/platforms_icons/x-verdict.svg')" alt="X-Verdict">
                </div>
              </a>

              <a v-if="allowed_app_keys.includes('proba')" class="app-item d-flex" @click="launch_platform('proba')">
                <div class="app-icon-wrapper d-flex">
                  <img :src="require('@/assets/platforms_icons/proba-analytics.svg')" alt="Analytics">
                </div>
              </a>

              <a v-if="allowed_app_keys.includes('complyon_onboard')" class="app-item d-flex" @click="launch_platform('complyon_onboard')">
                <div class="app-icon-wrapper d-flex">
                  <img :src="require('@/assets/platforms_icons/Onboardid.png')" alt="OnboardID">
                </div>
              </a>
            </div>
          </div>
        </div>

        <div class="dropdown">
          <button
            type="button"
            class="btn btn-link mobile-navbar-icon-btn position-relative text-dark p-0"
            id="mobileNotificationsDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-label="Open notifications"
            @click.prevent="open_notifications"
          >
            <i class="fa-regular fa-bell" aria-hidden="true"></i>
            <span
              v-if="unread_count > 0"
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger mobile-count-badge"
            >
              {{ unread_count > 99 ? '99+' : unread_count }}
            </span>
          </button>

          <div class="dropdown-menu dropdown-menu-end p-0 shadow border rounded-3 notification-dropdown" aria-labelledby="mobileNotificationsDropdown">
            <div class="d-flex justify-content-between align-items-start px-3 py-3 border-bottom bg-white position-sticky top-0">
              <h6 class="mb-0 fw-bold gradient-text fs-6">Notifications</h6>
              <button type="button" class="btn-close" aria-label="Close"></button>
            </div>
            <div class="bg-light notification-list overflow-auto">
              <div v-if="loading_notifications" class="text-center py-5">
                <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                <div class="small text-muted mt-2">Loading notifications...</div>
              </div>
              <div v-else-if="notifications.length === 0" class="text-center py-5 text-muted">
                <i class="fa-regular fa-bell fs-4"></i>
                <p class="mt-3 mb-0 small">No notifications</p>
              </div>
              <div v-else class="p-2">
                <div
                  v-for="notif in notifications"
                  :key="`mobile-${notif.id}`"
                  class="bg-white rounded mb-2 p-3 position-relative notification-card"
                  :class="{ 'notification-unread': notif.status !== 'READ' }"
                  @click="handle_notification_click(notif)"
                  style="cursor: pointer;"
                >
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <p class="mb-1 fw-normal text-dark text-xxsmall lh-sm pe-2">{{ notif.message }}</p>
                    <button
                      @click.stop="dismiss_notification(notif.id)"
                      class="btn-close btn-close-sm text-xxsmall"
                      aria-label="Close"
                    ></button>
                  </div>
                  <small class="text-muted text-xxsmall">{{ format_time_ago(notif.created_at) }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dropdown">
          <button
            type="button"
            class="btn mobile-user-avatar rounded-circle text-white fw-bold p-0 shadow-sm"
            id="mobileProfileDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-label="Open profile menu"
          >
            {{ user_initials }}
          </button>

          <div class="dropdown-menu dropdown-menu-end profile-dropdown p-0 border-0 shadow overflow-hidden" aria-labelledby="mobileProfileDropdown">
            <div class="profile-dropdown-header text-center text-white p-4">
              <div class="profile-dropdown-avatar rounded-circle bg-white text-dark fw-bold d-inline-flex align-items-center justify-content-center mb-3">
                {{ user_initials }}
              </div>
              <div class="fw-bold text-truncate">{{ user_display_name }}</div>
              <div v-if="user_email" class="small opacity-75 text-truncate">{{ user_email }}</div>
              <span v-if="user_role_label" class="badge rounded-pill bg-danger mt-2">{{ user_role_label }}</span>
            </div>

            <div class="profile-dropdown-body bg-white">
              <router-link
                v-if="can_access_settings"
                to="/main_settings"
                class="dropdown-item profile-admin-link d-flex align-items-center gap-3 py-3"
              >
                <i class="fa-solid fa-sliders text-danger" aria-hidden="true"></i>
                <span class="flex-grow-1">
                  <span class="d-block fw-semibold">Admin Control Centre</span>
                  <small class="d-block text-muted">Users, roles, branding &amp; governance</small>
                </span>
                <i class="fa-solid fa-chevron-right text-danger small" aria-hidden="true"></i>
              </router-link>
              <router-link
                to="/profile"
                class="dropdown-item d-flex align-items-center gap-3 py-3"
              >
                <i class="fa-solid fa-user text-secondary" aria-hidden="true"></i>
                <span>My Profile</span>
              </router-link>
              <div class="dropdown-divider my-1"></div>
              <button
                type="button"
                class="dropdown-item d-flex align-items-center gap-3 py-3 text-danger fw-semibold"
                @click="logout"
              >
                <i class="fa-solid fa-arrow-right-from-bracket" aria-hidden="true"></i>
                <span>Log out</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="desktop-navbar-content d-none d-lg-flex align-items-center w-100 p-2">
  <!-- Logo with Dynamic Branding -->
  <div class="ms-4 d-flex align-items-center">
    <router-link to="/home">
      <img 
        :src="get_navbar_logo_src()"
        class="navbar-logo" 
        alt="Logo"
        @error="handle_navbar_logo_error"
      />
    </router-link>

    <!-- Page heading, only on certain pages, right next to logo -->
    <div class="d-flex align-items-center ms-5 mt-3">
      <h3 class="informed-heading mb-0">
        <span v-if="$route.name === 'Ziva'" class="gradient-text fw-bold">
          Ziva Assistant
        </span>
        <span v-if="$route.name === 'Create'" class="gradient-text fw-bold">
          Workspaces
        </span>
        <span v-if="$route.name === 'Drive'" class="gradient-text fw-bold">
          AIC Drive
        </span>
        <span v-if="$route.name === 'MainSettings'" class="gradient-text fw-bold">
          Settings
        </span>
        <span v-if="$route.name === 'Chat'" class="gradient-text fw-bold">
          ONE Chat
        </span>
        <span v-if="$route.name === 'AuditTrail'" class="gradient-text fw-bold">
          Audit Trail
        </span>
        <span v-if="$route.name === 'Permission'" class="gradient-text fw-bold">
          Permissions
        </span>
        <span v-if="$route.name === 'Role'" class="gradient-text fw-bold">
          Roles
        </span>
        <span v-if="$route.name === 'Settings'" class="gradient-text fw-bold">
          Users
        </span>
        <span v-if="$route.name === 'Profile'" class="gradient-text fw-bold">
          Profile
        </span>
        <span v-if="$route.name === 'PlatformManagement'" class="gradient-text fw-bold">
          Platform Management
        </span>
      </h3>
    </div>
  </div>

  <!-- Search input, show on all except Home -->
  <div v-if="$route.name !== 'Home'" class="ms-4 me-3 flex-grow-1 position-relative">
    <div class="navbar-search d-flex justify-content-end">
      <div class="w-25">
        <input
          class="form-control text-dark"
          type="search"
          placeholder="Search"
          @mousedown="open_search_modal_from_nav"
          @keydown.enter.prevent="run_search(search_query, 0, true)"
          :class="{ 'd-none': !is_demo_domain }"
        />
      </div>
    </div>
  </div>


  <!-- Notifications, messages, user profile always visible -->
  <div class="navbar-links d-flex align-items-center ms-3 me-3">
    <div class="dropdown me-3">
      <a href="#" class="position-relative d-flex align-items-center justify-content-center" id="notificationsDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        @click.prevent="open_notifications">
        <i class="fa-regular fa-bell" aria-label="Notifications"></i>
        <span
          v-if="unread_count > 0"
          class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-xxsmall"
        >
          {{ unread_count > 99 ? '99+' : unread_count }}
        </span>
      </a>

      <div class="dropdown-menu dropdown-menu-end p-0 shadow border rounded-3 notification-dropdown" aria-labelledby="notificationsDropdown">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-start px-3 py-3 border-bottom bg-white position-sticky top-0">
          <h6 class="mb-0 fw-bold gradient-text fs-6">Notifications</h6>
          <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center">
              <!-- Desktop actions -->
              <div class="d-none d-sm-flex gap-2">
                <button
                  v-if="unread_count > 0"
                  @click="mark_all_read"
                  class="btn btn-link text-decoration-none p-0 text-xxsmall text-secondary"
                  title="Mark all as read"
                >
                  <i class="fa-solid fa-check"></i>Mark all read ({{ unread_count }})
                </button>

                <button
                  v-if="notifications.length > 0"
                  @click="dismiss_all"
                  class="btn btn-link text-decoration-none p-0 text-danger text-xxsmall"
                >
                <i class="fa-solid fa-trash"></i> Clear all
                </button>
              </div>

            <!-- Mobile actions -->
            <div class="d-flex d-sm-none w-100 justify-content-end">
              <button
                type="button"
                class="dropdown-item p-0"
                aria-label="Close"
              >
                <span class="btn-close"></span>
              </button>
            </div>
          </div>
        </div>

        <!-- Notifications List -->
        <div class="bg-light notification-list overflow-auto">
          <div v-if="loading_notifications" class="text-center py-5">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            <div class="small text-muted mt-2">Loading notifications...</div>
          </div>

          <div v-else-if="notifications.length === 0" class="text-center py-5 text-muted">
            <i class="fa-regular fa-bell fs-4" aria-hidden="true"></i>
            <p class="mt-3 mb-0 small">No notifications</p>
          </div>

          <div v-else class="p-2">
            <div
              v-for="notif in notifications"
              :key="notif.id"
              class="bg-white rounded mb-2 p-3 position-relative notification-card"
              :class="{ 'notification-unread': notif.status !== 'READ' }"
              @click="handle_notification_click(notif)"
              style="cursor: pointer;"
            >
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="flex-grow-1 pe-2">
                  <p class="mb-1 fw-normal text-dark text-xxsmall lh-sm">
                    {{ notif.message }}
                  </p>
                </div>
                <button
                  @click.stop="dismiss_notification(notif.id)"
                  class="btn-close btn-close-sm text-xxsmall"
                  aria-label="Close"
                ></button>
              </div>

              <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <button
                  v-if="notif.status !== 'READ'"
                  @click.stop="mark_notification_read(notif.id)"
                  class="btn btn-link text-decoration-none p-0 text-secondary text-xxsmall"
                >
                  ✓ Mark as read
                </button>
                <small class="text-muted ms-auto text-xxsmall">
                  {{ format_time_ago(notif.created_at) }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a href="#" class="me-3">
      <router-link to="/chat" class="me-3 d-flex align-items-center position-relative" active-class="active-nav-link">
        <i class="fa-regular fa-message" aria-label="One Chat"></i>

        <span
          v-if="unread_chat_count > 0"
          class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-xxsmall"
        >
          {{ unread_chat_count > 99 ? '99+' : unread_chat_count }}
        </span>
      </router-link>
    </a>
    <div class="dropdown">
      <button
        type="button"
        class="user-profile align-items-center justify-content-center d-flex border-0"
        id="desktopProfileDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="Open profile menu"
      >
        <div v-if="user && user.first_name && user.last_name" class="user-initials text-dark fw-bold">
          {{ user_initials }}
        </div>
        <div v-else class="user-profile-placeholder">
          <img :src="require('@/assets/profile_placeholder.svg')" class="rounded-circle" />
        </div>
      </button>

      <div class="dropdown-menu dropdown-menu-end p-2 border-0 shadow rounded-3" aria-labelledby="desktopProfileDropdown">
          <button
            type="button"
            class="dropdown-item d-flex align-items-center gap-3 py-3"
            @click="open_user_modal"
            data-bs-toggle="modal"
            data-bs-target="#user_info_modal"
          >
            <i class="fa-solid fa-user text-secondary" aria-hidden="true"></i>
            <span>My Profile</span>
          </button>
      </div>
    </div>
  </div>
  </div>

</nav>

<!-- USER INFO MODAL -->

<div class="modal fade" id="user_info_modal" tabindex="-1" aria-labelledby="userInfoModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">User <span class="gradient-text fw-bold">Information</span></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <!-- Modal Body -->
      <div class="modal-body">
        <div v-if="user">
          <div class="row">
            <div class=" col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small" for="first_name">First Name</label>
              <input type="text" id="surname" class="form-control form-control-sm text-black" placeholder=" "
                v-model="user.first_name" :disabled="!edit_mode" />
            </div>
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small" for="last_name">Last Name</label>
              <input type="text" class="form-control form-control-sm" placeholder=" " v-model="user.last_name"
                :disabled="!edit_mode">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small" for="email">Email</label>
              <input type="text" class="form-control form-control-sm" placeholder=" " v-model="user.email"
                :disabled="!edit_mode" @input="on_email_input" @blur="email_touched = true"
                :class="{'is-invalid': email_touched && !is_email_valid}">
              <div v-if="email_touched && !is_email_valid" class="invalid-feedback">
                {{ email_error || 'Please enter a valid email address.' }}
              </div>
            </div>
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small" for="role">Role</label>
              <input type="text" class="form-control form-control-sm" placeholder=" " v-model="user.role" disabled>
            </div>
          </div>
        </div>
        <div v-if="user.client_type && user.client_type.toLowerCase() === 'organization'">
          <h6 class="text-start mb-3 mt-2 ms-1">Organization Details</h6>
          <div class="row">
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">Organization Name</label>
              <input type="text" class="form-control form-control-sm" v-model="new_company.company_name"
                :disabled="!edit_mode">
            </div>
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">Registration Number</label>
              <input type="text" class="form-control form-control-sm" v-model="new_company.registration_number"
                :disabled="!edit_mode" @input="on_registration_input" @keypress="only_digits($event)"
                :class="{'is-invalid': registration_error}"  placeholder="YYYY/NNNNNN/NN">
              <div v-if="registration_error" class="invalid-feedback">
                {{ registration_error }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">VAT Number</label>
              <input type="text" class="form-control form-control-sm" v-model="new_company.vat_number"
                @keypress="only_digits($event)" :disabled="!edit_mode" @input="validate_vat"
                :class="{'is-invalid': vat_error}" placeholder="0123456789">
              <div v-if="vat_error" class="invalid-feedback">
                {{ vat_error }}
              </div>
            </div>

            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">Phone Number</label>
              <input type="text" class="form-control form-control-sm" v-model="new_company.phone_number"
                :disabled="!edit_mode" @keypress="only_digits($event)">
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group mb-2">
              <label class="text-start d-flex ms-2 small">Address</label>
              <input type="text" class="form-control form-control-sm" v-model="new_company.address"
                :disabled="!edit_mode">
            </div>
          </div>
        </div>
        <div v-else>
          <h5 class="text-start mt-4 mb-3">Individual Details</h5>
          <div class="row">
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">Phone Number</label>
              <input type="text" class="form-control form-control-sm" v-model="user_profile.phone_number"
                :disabled="!edit_mode" @keypress="only_digits($event)" required>
            </div>
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">Address</label>
              <input type="text" class="form-control form-control-sm" v-model="user_profile.address"
                :disabled="!edit_mode" required>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">ID Number</label>
              <input type="text" class="form-control form-control-sm" v-model="user_profile.id_number"
                @input="validate_id_number" @keypress="only_digits($event)" :disabled="!edit_mode"
                :class="{'is-invalid': id_number_error}">
              <div v-if="id_number_error" class="invalid-feedback">{{ id_number_error }}</div>
            </div>
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">Province</label>
              <input type="text" class="form-control form-control-sm" v-model="user_profile.province"
                :disabled="!edit_mode">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">Country</label>
              <input type="text" class="form-control form-control-sm" v-model="user_profile.country"
                :disabled="!edit_mode">
            </div>
            <div class="col-md-6 form-group mb-2">
              <label class="text-start d-flex ms-2 small">Gender</label>
              <input type="text" class="form-control form-control-sm" v-model="user_profile.gender"
                :disabled="!edit_mode">
            </div>
          </div>
        </div>
        <!-- Modal Footer -->
        <div class="modal-footer">
          <button v-if="!edit_mode" @click="edit_mode = true" class="btn cta-button text-white">Edit</button>
          <button v-else @click="save_changes" class="btn cta-button text-white">Save Changes</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- GLOBAL SEARCH MODAL -->
<div class="modal fade" id="global_search_modal" tabindex="-1" ref="global_search_modal" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content rounded-4 shadow">
      <div class="modal-header">
        <h6 class="modal-title">Global Search</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                @click="close_search_modal"></button>
      </div>

      <div class="modal-body p-0">
        <!-- Sticky search bar inside modal -->
        <div class="p-3 border-bottom position-sticky top-0 bg-white">
          <input
            v-model="search_query"
            class="form-control"
            type="search"
            placeholder="Type to search across your data…"
            @input="on_search_input"
            @keydown.enter.prevent="run_search(search_query, 0, true)"
          />
        </div>

        <div class="p-3">
          <!-- Loading -->
          <div v-if="is_searching" class="text-center py-4">
            <div class="spinner-border" role="status"></div>
            <div class="small text-muted mt-2">Searching…</div>
          </div>

          <!-- Empty -->
          <div v-else-if="!results.length" class="text-center text-muted py-4">
          </div>

          <!-- Grouped results -->
          <div v-else>
            <div v-for="(items, type) in grouped_results" :key="type" class="mb-3">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="badge bg-dark-subtle text-dark text-uppercase">{{ type }}</span>
                <small class="text-muted">{{ items.length }} result(s)</small>
              </div>

              <div class="list-group rounded-4">
                <button
                  v-for="(r,i) in items"
                  :key="`${type}-${r.id}-${i}`"
                  class="list-group-item list-group-item-action d-flex align-items-start gap-2"
                  @click="open_result(r)"
                >
                  <div class="flex-grow-1">
                    <div class="fw-semibold">{{ r.title || '—' }}</div>
                    <div class="text-muted text-xxs">{{ r.subtitle || '' }}</div>
                  </div>
                  <span class="btn btn-sm upload-button">Open</span>
                </button>
              </div>
            </div>

            <!-- Pager -->
            <div class="d-flex justify-content-between align-items-center pt-2">
              <small class="text-muted">Total: {{ total_count }}</small>
              <div class="btn-group btn-group-sm">
                <button class="btn upload-button" :disabled="offset===0" @click="page_prev">Prev</button>
                <button class="btn upload-button" :disabled="offset+limit>=total_count" @click="page_next">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <small class="text-muted me-auto">
          Showing {{ Math.min(offset+limit, total_count) }} of {{ total_count }}
        </small>
      </div>
    </div>
  </div>
</div>
<!-- /GLOBAL SEARCH MODAL -->
